import { useRef } from "react"

import useHover from "$/hooks/use-hover"
import { Option } from "$/models/option"

import { Button } from "@/3514/components"
import { buildCssClassName } from "@/3514/utils"
import WithMenuCard from "@/shared/card/WithMenuCard"
import DragElement from "@/shared/drag-n-drop/DragElement"

import { OldBelief } from "../model/types/old-belief"

import "./styles.scss"

type Props = {
    goal: OldBelief
    oldBeliefIndex: number
    provider: any
    snapshot: any
    isArchived: boolean
    index: number
    showDrag?: boolean
    onArchiveClick: (index: number) => void
    onClickOldeBelief: (index: number) => void
}

const ITEMS = [new Option({ value: "edit", label: "Edit" }), new Option({ value: "archive", label: "Archive" })]
const ARCHIVE = [new Option({ value: "unarchive", label: "Unarchive" })]

export const OldBeliefGoalCard = ({
    index,
    goal,
    oldBeliefIndex,
    isArchived,
    provider,
    showDrag = true,
    snapshot,
    onClickOldeBelief,
    onArchiveClick
}: Props) => {
    const cardRef = useRef(null)
    const hover = useHover(provider)

    const onMenuItemClick = (item: Option) => {
        if (item.value === "archive" || item.value === "unarchive") {
            onArchiveClick(index)
            return
        }

        if (isArchived) {
            return
        }

        onClickOldeBelief(oldBeliefIndex)
    }
    const onClick = () => {
        if (isArchived) {
            return
        }

        onClickOldeBelief(oldBeliefIndex)
    }

    return (
        <div ref={provider}>
            <div className="old-belief-goal-card-wrapper flex w-full" ref={cardRef}>
                {showDrag && <DragElement snapshot={snapshot} />}
                <WithMenuCard
                    cardClassName={buildCssClassName("pr-4 old-belief-card", { "bg-light-accent": isArchived })}
                    menuItems={isArchived ? ARCHIVE : ITEMS}
                    onMenuItemClick={onMenuItemClick}
                    menuOffsets={{ right: -100, top: 45 }}
                    menuPosition="right"
                    showThreeDots={hover}
                >
                    <Button isContainer className="p-0 w-100 h-100 old-belief-goal-button" onClick={onClick}>
                        <p className="m-0 color-gray fs-14 font-italic text-center">{goal.title}</p>
                    </Button>
                </WithMenuCard>
            </div>
        </div>
    )
}
